import { Direction } from '@angular/cdk/bidi';
import {
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, tap } from 'rxjs';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  REMOVE_PRICE,
  RESEARCH_WITHOUT_FILTER,
  SHOW_PRICE,
  THE_REQUESTED_PATH,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { RoutePlanning } from 'src/app/modules/route-planner/interfaces/route-planning/@route-planning.interface';
import { TariffProfile } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/tariff-profile.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { SourceDestinationResultsMapComponent } from '../source-destination-results-map/source-destination-results-map.component';

@Component({
    selector: 'app-source-destination-results-list',
    templateUrl: './source-destination-results-list.component.html',
    styleUrls: ['./source-destination-results-list.component.scss'],
    standalone: false
})
export class SourceDestinationResultListComponent implements OnInit {
  @Output() onResultClick = new EventEmitter<{
    route: RoutePlanning;
    showRoutePrice: boolean;
  }>();
  @Output() onResultHover = new EventEmitter<RoutePlanning>();

  @Input() results: RoutePlanning[];
  @Input() resubmittedWithoutFilters: boolean;
  @Input() isMobile: boolean;
  @Input() isLoading: boolean = false;

  direction: Direction;
  showRoutePrice: boolean = false;
  selectedProfile: TariffProfile;

  priceProfileFormControl = new FormControl<TariffProfile>(null);
  priceCalculationLabel: string;

  noResultForText: string;
  reSearchWithoutFiltersText: string;
  constructor(private readonly languageService: LanguageService) {
    this.priceProfileFormControl.valueChanges.subscribe(
      (profile) => (this.selectedProfile = profile)
    );
  }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();
    if(!this.showRoutePrice) {
      this.priceProfileFormControl.disable();
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.priceCalculationLabel = SHOW_PRICE[language.language];
      this.noResultForText = THE_REQUESTED_PATH[language.language];
      this.reSearchWithoutFiltersText =
        RESEARCH_WITHOUT_FILTER[language.language];
    });
  }

  togglePriceCalculation(): void {
    this.showRoutePrice = !this.showRoutePrice;
    if (!!this.showRoutePrice) {
      this.priceProfileFormControl.enable();
    } else {
      this.priceProfileFormControl.disable();
    }
  }
}
